import React from 'react';

enum AlertLevelMap {
    "information" = 0,
    "warning" = 1,
    "alert" = 2,
}

type ProductAvailability = {
    alertLevel: number,
    calloutMessage: string,
    deliveryMessage: string,
    estimatedDeliveryDate: string,
    estimatedDeliveryDateEndRange: string,
    itemId: string,
    requiresMessageDescriptions: boolean,
    stockMessage: string,
    unitId: string,
    wbTruckDelivery: boolean,
    doPreventAddToCart: boolean,
    preventPurchaseMessage: string
}

type ProductAvailabilityProps = {
    availabilityInfo: ProductAvailability,
    smallText?: boolean,
    hostUrl?: string
}

export const ProductAvailability = ({ availabilityInfo, smallText, hostUrl = "https://www.wbmason.com/" }: ProductAvailabilityProps) => {
    const renderMobile = (productAvailability: ProductAvailability) => {
        return (
            (productAvailability.doPreventAddToCart) ?
                <div className="col messages d-sm-none prevent-purchase">
                    <span className="font-weight-bold">{productAvailability.preventPurchaseMessage}</span>
                </div>
                :
                <div className="col messages d-sm-none">
                    {productAvailability.wbTruckDelivery && (
                        <img
                            alt="truck"
                            src={"https://images.wbmason.com/65/wb_truck.png"}
                        />
                    )}
                    {productAvailability.calloutMessage && (
                        <span className="callout-message">{productAvailability.calloutMessage} </span>
                    )}

                    {productAvailability.requiresMessageDescriptions ? (
                        <a
                            href={`${hostUrl}PopupPage.aspx?cpi=Availability`}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="availability"
                        >
                            <span>{productAvailability.deliveryMessage}</span>
                        </a>
                    )
                        :
                        (
                            <span>{productAvailability.deliveryMessage}</span>
                        )}
                </div>
        );
    }

    function popUp(event: React.MouseEvent<HTMLAnchorElement>) {
        event.stopPropagation();
        var windowPopup = window.open(hostUrl + "PopupPage.aspx?cpi=Availability", "", "menubar=0,scrollbars=1,toolbar=0,resizable=0,status=0,location=0,width=345,height=400");
        windowPopup?.focus();
        windowPopup?.moveTo(30, 30);
    }

    const renderDesktop = (productAvailability: ProductAvailability) => {
        return (
            <div className="d-none d-sm-flex">
                <div className="row no-gutters">
                    {(productAvailability.doPreventAddToCart) ?
                        <div className="col messages prevent-purchase">
                            <span className="font-weight-bold">{productAvailability.preventPurchaseMessage}</span>
                        </div>
                        :
                        <>
                            <div className="messages">
                                <div className="row no-gutters">
                                    <div className="col-12 callout-message">
                                        {productAvailability.calloutMessage && (
                                            <span>{productAvailability.calloutMessage}</span>
                                        )}
                                    </div>
                                    <div className="availability-container">
                                        {productAvailability.wbTruckDelivery && (
                                            <img
                                                alt="truck"
                                                src={"https://images.wbmason.com/65/wb_truck.png"}
                                            />
                                        )}

                                        {productAvailability.requiresMessageDescriptions ? (
                                            <a
                                                className="wbm-button btn btn-link medium"
                                                onClick={(event) => popUp(event)}
                                                aria-label="availability"
                                            >
                                                <span>{productAvailability.deliveryMessage}</span>
                                            </a>
                                        )
                                            :
                                            (
                                                <span>{productAvailability.deliveryMessage}</span>
                                            )}
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        );
    }

    return (
        <div
            className={
                `row no-gutters wbm-product-availability-${AlertLevelMap[availabilityInfo.alertLevel]}${smallText ? " small-text" : ""}`
            }
            key={`${availabilityInfo.itemId}-${availabilityInfo.itemId}-availability`}
        >
            {renderDesktop(availabilityInfo)}
            {renderMobile(availabilityInfo)}
        </div>
    );
}